import React, { ReactNode } from "react";
import { Tooltip, IconButton } from "@mui/material";

interface ActionButtonProps {
  title: string;
  onClick: () => void;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  title,
  onClick,
  children,
  className,
  disabled,
}) => {
  return (
    <Tooltip title={title} disableTouchListener={disabled}>
      <IconButton
        size="large"
        edge="end"
        aria-haspopup="true"
        onClick={onClick}
        className={className}
        disabled={disabled}
      >
        {children}
      </IconButton>
    </Tooltip>
  );
};

export default ActionButton;
